import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";
import {createAlert, submitPrint} from "./utils_element";
import {appFormRequest, appQuery, appRequest} from "./utils_request";

export const printAccompaniment = (data, callFunction) => {
    submitPrint(data, callFunction, urls.printAccompaniment);
};

export const init = () => {
    $('#dataTable').on('draw.dt', () => {
        saveDisplayList();
    });
};

const saveDisplayList = () => {
    let dataTable = $('#dataTable').DataTable();
    let data = dataTable.rows({search: 'applied'}).data().toArray();
    // fetch don't run
    $.ajax(urls.saveVehicleList, {
        data: {data: JSON.stringify(data)},
        type: "POST",
        success: (r) => {
            // console.log(r);
        }
    })
};

export const submitActivitiesVHStatus = (lines, callFunction) => {
    let data = {lines: lines, activities_vh_status: $('#activitiesVHStatus').serializeArray()};
    if (document.getElementById('hasTemplate') !== null) {
        return window.location.reload()
    }
    appRequest(urls.editVehicleStatus, data)
        .then((resp) => {
            if (resp.valid) {
                callFunction.addGlobalSuccess('Activité(s) sélectionnée(s) créée(s)');
                window.location.reload();
            } else {
                callFunction.addUnknowError();
            }
        });
};

export const updateDayDateCG = (rows) => {
    var callFunction = new CallFunction('updateDayDateCG', 'fad fa-calendar-edit');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Mise à jour de DateCG.');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    callFunction.addValidateBtn(function () {
        var data = rows.toArray();
        callFunction.startLoading();
        $.ajax({
            data: {data},
            type: 'POST',
            url: urls.updateDayDateCG,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (var i = 0; i < rep.success.length; i++) {
                    callFunction.addLineResult('Champ dateCG mis à jour pour le VH : ' + rep.success[i].U_W3C_NOID, 'success')
                }
                for (var i = 0; i < rep.error.length; i++) {
                    callFunction.addLineResult('Impossible de mettre à jour le champ dateCG pour le VH :' + rep.error[i], 'error')
                }
            },
            complete: function (rep) {
                callFunction.stopLoading();
                callFunction.addReloadButton();
            },
            error: function (rep) {
                callFunction.addUnknowError();
            }
        })
    })
};


export const editVehicleReceivedCG = (rows, index = 0) => {
    let callFunction = new CallFunction('editVehicleReceivedCG', 'fad fa-layer-plus fa-2x'),
        dataLine = rows[index],
        url = urls.editVehicleReceivedCG.replace('toRpDocEntryVH', dataLine['DocEntryVH']);

    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Enregistrement réception CG (' + (index + 1) + '/' + rows.length + ')');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.startLoading();

    appQuery(url, false).then(resp => {
        callFunction.modalBody.innerHTML = resp;
        $('.datepicker-here').datepicker();
        callFunction.stopLoading();
        callFunction.addValidateBtn(() => {
            callFunction.startLoading();
            let form = $(callFunction.modalBody.querySelector('form')).serialize();
            appFormRequest(url, form, true)
                .then(e => {
                    console.log(e);
                    callFunction.stopLoading();

                    if (e.hasOwnProperty('error')){
                        let alert = callFunction.modalBody.querySelector('.alert') !== null
                            ? callFunction.modalBody.querySelector('.alert')
                            : createAlert('danger', e.error, 'fad fa-exclamation-triangle');
                        alert.innerText = e.error;
                        callFunction.modalBody.prepend(alert);
                        return;
                    }

                    if ((index + 1) === rows.length) {
                        callFunction.addReloadButton();
                        return callFunction.addGlobalSuccess('Modifications effectuées.')
                    }
                    index++;
                    editVehicleReceivedCG(rows, index);
                })
                .catch(e => {
                    console.log(e);
                    callFunction.stopLoading();
                    editVehicleReceivedCG(rows, index);
                })
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/display_statuts.js